import React from 'react';
import { VIEWPORT } from '~/utils/constants';
import { useViewport } from '~/utils/viewport-provider';

const DynamicFormImage: React.FC<{
  image: ImageField<ReusableImageField>;
}> = ({ image }) => {
  const { viewport } = useViewport();
  const { scale, offset } = image;

  const imageStyle = {
    '--translate-x': `${offset?.horizontal ?? 0}rem`,
    '--translate-y': `${offset?.vertical ?? 0}rem`,
    '--scale-x': scale?.x ?? 1,
    '--scale-y': scale?.y ?? 1,
  } as React.CSSProperties;

  if (viewport.device === VIEWPORT.mobile) {
    return null;
  }

  return (
    <div className='absolute left-full top-0 z-[1] h-fit w-[32rem]'>
      <img
        src={image.src}
        alt={image.alt}
        title={image.alt}
        className='dynamic_form__cover'
        style={imageStyle}
      />
    </div>
  );
};

export default DynamicFormImage;
